import React from "react"
import { getMeData } from "../../utils"
import { useLifelongLearningEnabled } from "./useLifelongLearningEnabled"
import { useLifelongLearningQuery } from "./useLifelongLearningQuery"

export const withLifelongLearningMe = query => WrappedComponent => props => {
  const { data, loading, me, error, refetch } = useLifelongLearningQuery(query)
  return (
    <WrappedComponent
      {...props}
      data={data}
      loading={loading}
      me={me}
      error={error}
      refetch={refetch}
    />
  )
}

// Loads `me` from the api-v3 query, or from the Membership query (adapted to the
// same `me` shape) when the lifelong learning flag is on.
export const withEducationMe = (v3Query, lifelongLearningQuery) => {
  const fromV3 = getMeData(v3Query)
  const fromLifelongLearning = withLifelongLearningMe(lifelongLearningQuery)

  return WrappedComponent => {
    const V3Component = fromV3(WrappedComponent)
    const LifelongLearningComponent = fromLifelongLearning(WrappedComponent)

    return props =>
      useLifelongLearningEnabled() ? (
        <LifelongLearningComponent {...props} />
      ) : (
        <V3Component {...props} />
      )
  }
}
